module.exports = __webpack_public_path__ + "img/app-siabg.874cd90d.jpg";